type Args = Array<Record<string, number> | undefined>;

export const transfromRewardsToCommonFormat = (
  rewards: Args,
): { item: string; value: number }[] =>
  rewards
    .filter((reward) => !!reward)
    .flatMap((reward) => {
      return Object.entries(reward).map(([item, value]) => ({ item, value }));
    });
